// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";

// const Sidebar = () => {
//   const navigate = useNavigate();

//   const [openDropdowns, setOpenDropdowns] = useState({
//     dashboard: false,
//     fundManagement: false,
//     registrationTeam: false,
//     incomeEarnings: false,
//     bonanzaRewards: false,
//     airdrop: false,
//     withdrawal: false,
//     settings: false,
//   });

//   const toggleDropdown = (key) => {
//     setOpenDropdowns((prev) => ({
//       ...prev,
//       [key]: !prev[key],
//     }));
//   };

//   return (
//     <div className="sidebar-body">
//       <ul className="nav" id="sidebarNav">

//         {/* Dashboard */}
//         <li className="nav-item has-dropdown">
//           <a
//             href="#dashboard"
//             className="nav-link d-flex align-items-center justify-content-between"
//             onClick={(e) => {
//               e.preventDefault();
//               toggleDropdown("dashboard");
//             }}
//             aria-expanded={openDropdowns.dashboard}
//           >
//             <div className="d-flex align-items-center">
//               <i className="link-icon me-2" data-lucide="home"></i>
//               <span className="link-title nav-item nav-category">
//                 Dashboard
//               </span>
//             </div>
//             <i
//               className={`dropdown-icon ${
//                 openDropdowns.dashboard ? "icon-rotate" : ""
//               }`}
//               data-lucide="chevron-down"
//             ></i>
//           </a>

//           <ul
//             className={`nav-dropdown ${
//               openDropdowns.dashboard ? "show" : ""
//             }`}
//           >
//             <li className="nav-dropdown-item">
//               <a href="#" className="nav-link d-flex align-items-center">
//                 <i className="link-icon me-2" data-lucide="vault"></i>
//                 <span className="link-title">Quantum Main Vault</span>
//               </a>
//             </li>

//             <li className="nav-dropdown-item">
//               <a href="#" className="nav-link d-flex align-items-center">
//                 <i className="link-icon me-2" data-lucide="wallet"></i>
//                 <span className="link-title">My Wallet Balance</span>
//               </a>
//             </li>
//           </ul>
//         </li>

//         {/* Fund Management */}
//         <li className="nav-item has-dropdown">
//           <a
//             href="#fundManagement"
//             className="nav-link d-flex align-items-center justify-content-between"
//             onClick={(e) => {
//               e.preventDefault();
//               toggleDropdown("fundManagement");
//             }}
//             aria-expanded={openDropdowns.fundManagement}
//           >
//             <div className="d-flex align-items-center">
//               <i className="link-icon me-2" data-lucide="dollar-sign"></i>
//               <span className="link-title nav-item nav-category">
//                 Fund Management
//               </span>
//             </div>
//             <i
//               className={`dropdown-icon ${
//                 openDropdowns.fundManagement ? "icon-rotate" : ""
//               }`}
//               data-lucide="chevron-down"
//             ></i>
//           </a>

//           <ul
//             className={`nav-dropdown ${
//               openDropdowns.fundManagement ? "show" : ""
//             }`}
//           >
//             <li className="nav-dropdown-item">
//               <a href="#" className="nav-link d-flex align-items-center">
//                 <i className="link-icon me-2" data-lucide="fuel"></i>
//                 <span className="link-title">FuelUp / Deposit</span>
//               </a>
//             </li>

//             <li className="nav-dropdown-item">
//               <a
//                 href="#"
//                 className="nav-link d-flex align-items-center"
//                 onClick={(e) => {
//                   e.preventDefault();
//                   navigate("/wallet-transfer");
//                 }}
//               >
//                 <i className="link-icon me-2" data-lucide="refresh-cw"></i>
//                 <span className="link-title">Wallet-to-Wallet Transfer</span>
//               </a>
//             </li>

//             <li className="nav-dropdown-item">
//               <a href="#" className="nav-link d-flex align-items-center">
//                 <i className="link-icon me-2" data-lucide="rotate-cw"></i>
//                 <span className="link-title">Re-TopUp (Mozumma)</span>
//               </a>
//             </li>

//             {/* New Menu Item for Wallet Transaction */}
//             <li className="nav-dropdown-item">
//               <a
//                 href="#"
//                 className="nav-link d-flex align-items-center"
//                 onClick={(e) => {
//                   e.preventDefault();
//                   navigate("/wallet-transaction");
//                 }}
//               >
//                 <i className="link-icon me-2" data-lucide="file-text"></i>
//                 <span className="link-title">Wallet Transaction</span>
//               </a>
//             </li>
//           </ul>
//         </li>

//         {/* Registration & Team */}
//         <li className="nav-item has-dropdown">
//           <a
//             href="#registrationTeam"
//             className="nav-link d-flex align-items-center justify-content-between"
//             onClick={(e) => {
//               e.preventDefault();
//               toggleDropdown("registrationTeam");
//             }}
//             aria-expanded={openDropdowns.registrationTeam}
//           >
//             <div className="d-flex align-items-center">
//               <i className="link-icon me-2" data-lucide="user-plus"></i>
//               <span className="link-title nav-item nav-category">
//                 Registration & Team
//               </span>
//             </div>
//             <i
//               className={`dropdown-icon ${
//                 openDropdowns.registrationTeam ? "icon-rotate" : ""
//               }`}
//               data-lucide="chevron-down"
//             ></i>
//           </a>

//           <ul
//             className={`nav-dropdown ${
//               openDropdowns.registrationTeam ? "show" : ""
//             }`}
//           >
//             <li className="nav-dropdown-item">
//               <a href="#" className="nav-link d-flex align-items-center">
//                 <i className="link-icon me-2" data-lucide="user-plus"></i>
//                 <span className="link-title">
//                   New Joining / Member Registration
//                 </span>
//               </a>
//             </li>

//             <li className="nav-dropdown-item">
//               <a href="#" className="nav-link d-flex align-items-center">
//                 <i className="link-icon me-2" data-lucide="users"></i>
//                 <span className="link-title">Crowd Sign-Ups</span>
//               </a>
//             </li>

//             <li className="nav-dropdown-item">
//               <a href="#" className="nav-link d-flex align-items-center">
//                 <i className="link-icon me-2" data-lucide="user-check"></i>
//                 <span className="link-title">My Direct Leads</span>
//               </a>
//             </li>

//             <li className="nav-dropdown-item">
//               <a href="#" className="nav-link d-flex align-items-center">
//                 <i className="link-icon me-2" data-lucide="network"></i>
//                 <span className="link-title">My Team Network</span>
//               </a>
//             </li>
//           </ul>
//         </li>

//         {/* Income & Earnings */}
//         <li className="nav-item has-dropdown">
//           <a
//             href="#incomeEarnings"
//             className="nav-link d-flex align-items-center justify-content-between"
//             onClick={(e) => {
//               e.preventDefault();
//               toggleDropdown("incomeEarnings");
//             }}
//             aria-expanded={openDropdowns.incomeEarnings}
//           >
//             <div className="d-flex align-items-center">
//               <i className="link-icon me-2" data-lucide="trending-up"></i>
//               <span className="link-title nav-item nav-category">
//                 Income & Earnings
//               </span>
//             </div>
//             <i
//               className={`dropdown-icon ${
//                 openDropdowns.incomeEarnings ? "icon-rotate" : ""
//               }`}
//               data-lucide="chevron-down"
//             ></i>
//           </a>

//           <ul
//             className={`nav-dropdown ${
//               openDropdowns.incomeEarnings ? "show" : ""
//             }`}
//           >
//             <li className="nav-dropdown-item">
//               <a href="#" className="nav-link d-flex align-items-center">
//                 <i className="link-icon me-2" data-lucide="layers"></i>
//                 <span className="link-title">Level Income</span>
//               </a>
//             </li>

//             <li className="nav-dropdown-item">
//               <a href="#" className="nav-link d-flex align-items-center">
//                 <i className="link-icon me-2" data-lucide="users"></i>
//                 <span className="link-title">Team Income</span>
//               </a>
//             </li>

//             <li className="nav-dropdown-item">
//               <a href="#" className="nav-link d-flex align-items-center">
//                 <i className="link-icon me-2" data-lucide="repeat"></i>
//                 <span className="link-title">Senior Re-TopUp Income</span>
//               </a>
//             </li>

//             <li className="nav-dropdown-item">
//               <a href="#" className="nav-link d-flex align-items-center">
//                 <i className="link-icon me-2" data-lucide="award"></i>
//                 <span className="link-title">CMD Bonus</span>
//               </a>
//             </li>

//             <li className="nav-dropdown-item">
//               <a href="#" className="nav-link d-flex align-items-center">
//                 <i className="link-icon me-2" data-lucide="bar-chart-3"></i>
//                 <span className="link-title">24 Max Directs Report</span>
//               </a>
//             </li>

//             <li className="nav-dropdown-item">
//               <a href="#" className="nav-link d-flex align-items-center">
//                 <i className="link-icon me-2" data-lucide="trending-up"></i>
//                 <span className="link-title">24 Max Income Report</span>
//               </a>
//             </li>

//             <li className="nav-dropdown-item">
//               <a href="#" className="nav-link d-flex align-items-center">
//                 <i className="link-icon me-2" data-lucide="trending-down"></i>
//                 <span className="link-title">24 Lowest Income Report</span>
//               </a>
//             </li>

//             <li className="nav-dropdown-item">
//               <a href="#" className="nav-link d-flex align-items-center">
//                 <i className="link-icon me-2" data-lucide="minus-circle"></i>
//                 <span className="link-title">24 Zero Income Report</span>
//               </a>
//             </li>

//             <li className="nav-dropdown-item">
//               <a href="#" className="nav-link d-flex align-items-center">
//                 <i className="link-icon me-2" data-lucide="pie-chart"></i>
//                 <span className="link-title">ROI Generation Overview</span>
//               </a>
//             </li>
//           </ul>
//         </li>

//         {/* Bonanza & Rewards */}
//         <li className="nav-item has-dropdown">
//           <a
//             href="#bonanzaRewards"
//             className="nav-link d-flex align-items-center justify-content-between"
//             onClick={(e) => {
//               e.preventDefault();
//               toggleDropdown("bonanzaRewards");
//             }}
//             aria-expanded={openDropdowns.bonanzaRewards}
//           >
//             <div className="d-flex align-items-center">
//               <i className="link-icon me-2" data-lucide="gift"></i>
//               <span className="link-title nav-item nav-category">
//                 Bonanza & Rewards
//               </span>
//             </div>
//             <i
//               className={`dropdown-icon ${
//                 openDropdowns.bonanzaRewards ? "icon-rotate" : ""
//               }`}
//               data-lucide="chevron-down"
//             ></i>
//           </a>

//           <ul
//             className={`nav-dropdown ${
//               openDropdowns.bonanzaRewards ? "show" : ""
//             }`}
//           >
//             <li className="nav-dropdown-item">
//               <a href="#" className="nav-link d-flex align-items-center">
//                 <i className="link-icon me-2" data-lucide="gift"></i>
//                 <span className="link-title">My Bonanza List</span>
//               </a>
//             </li>

//             <li className="nav-dropdown-item">
//               <a href="#" className="nav-link d-flex align-items-center">
//                 <i className="link-icon me-2" data-lucide="trophy"></i>
//                 <span className="link-title">Awards and Rewards</span>
//               </a>
//             </li>
//           </ul>
//         </li>

//         {/* Airdrop */}
//         <li className="nav-item has-dropdown">
//           <a
//             href="#airdrop"
//             className="nav-link d-flex align-items-center justify-content-between"
//             onClick={(e) => {
//               e.preventDefault();
//               toggleDropdown("airdrop");
//             }}
//             aria-expanded={openDropdowns.airdrop}
//           >
//             <div className="d-flex align-items-center">
//               <i className="link-icon me-2" data-lucide="cloud-snow"></i>
//               <span className="link-title nav-item nav-category">
//                 Airdrop
//               </span>
//             </div>
//             <i
//               className={`dropdown-icon ${
//                 openDropdowns.airdrop ? "icon-rotate" : ""
//               }`}
//               data-lucide="chevron-down"
//             ></i>
//           </a>

//           <ul
//             className={`nav-dropdown ${openDropdowns.airdrop ? "show" : ""}`}
//           >
//             <li className="nav-dropdown-item">
//               <a href="#" className="nav-link d-flex align-items-center">
//                 <i className="link-icon me-2" data-lucide="cloud-snow"></i>
//                 <span className="link-title">QI Airdrop</span>
//               </a>
//             </li>
//           </ul>
//         </li>

//         {/* Withdrawal */}
//         <li className="nav-item has-dropdown">
//           <a
//             href="#withdrawal"
//             className="nav-link d-flex align-items-center justify-content-between"
//             onClick={(e) => {
//               e.preventDefault();
//               toggleDropdown("withdrawal");
//             }}
//             aria-expanded={openDropdowns.withdrawal}
//           >
//             <div className="d-flex align-items-center">
//               <i className="link-icon me-2" data-lucide="log-out"></i>
//               <span className="link-title nav-item nav-category">
//                 Withdrawal
//               </span>
//             </div>
//             <i
//               className={`dropdown-icon ${
//                 openDropdowns.withdrawal ? "icon-rotate" : ""
//               }`}
//               data-lucide="chevron-down"
//             ></i>
//           </a>

//           <ul
//             className={`nav-dropdown ${
//               openDropdowns.withdrawal ? "show" : ""
//             }`}
//           >
//             <li className="nav-dropdown-item">
//               <a href="#" className="nav-link d-flex align-items-center">
//                 <i className="link-icon me-2" data-lucide="log-out"></i>
//                 <span className="link-title">Withdraw Funds</span>
//               </a>
//             </li>
//           </ul>
//         </li>

//         {/* Settings */}
//         <li className="nav-item has-dropdown">
//           <a
//             href="#settings"
//             className="nav-link d-flex align-items-center justify-content-between"
//             onClick={(e) => {
//               e.preventDefault();
//               toggleDropdown("settings");
//             }}
//             aria-expanded={openDropdowns.settings}
//           >
//             <div className="d-flex align-items-center">
//               <i className="link-icon me-2" data-lucide="settings"></i>
//               <span className="link-title nav-item nav-category">
//                 Settings
//               </span>
//             </div>
//             <i
//               className={`dropdown-icon ${
//                 openDropdowns.settings ? "icon-rotate" : ""
//               }`}
//               data-lucide="chevron-down"
//             ></i>
//           </a>

//           <ul
//             className={`nav-dropdown ${openDropdowns.settings ? "show" : ""}`}
//           >
//             <li className="nav-dropdown-item">
//               <a href="#" className="nav-link d-flex align-items-center">
//                 <i className="link-icon me-2" data-lucide="user"></i>
//                 <span className="link-title">My Profile</span>
//               </a>
//             </li>

//             <li className="nav-dropdown-item">
//               <a href="#" className="nav-link d-flex align-items-center">
//                 <i className="link-icon me-2" data-lucide="key"></i>
//                 <span className="link-title">Manage Crypto Addresses</span>
//               </a>
//             </li>

//             <li className="nav-dropdown-item">
//               <a href="#" className="nav-link d-flex align-items-center">
//                 <i className="link-icon me-2" data-lucide="shield"></i>
//                 <span className="link-title">Security Settings</span>
//               </a>
//             </li>

//             <li className="nav-dropdown-item">
//               <a
//                 href="#"
//                 className="nav-link d-flex align-items-center"
//                 onClick={(e) => {
//                   e.preventDefault();
//                   navigate("/payment-report");
//                 }}
//               >
//                 <i className="link-icon me-2" data-lucide="file-text"></i>
//                 <span className="link-title">Payment Report</span>
//               </a>
//             </li>
//           </ul>
//         </li>
//       </ul>
//     </div>
//   );
// };

// export default Sidebar;

import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const Sidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [openDropdowns, setOpenDropdowns] = useState({
    dashboard: false,
    fundManagement: false,
    registrationTeam: false,
    incomeEarnings: false,
    bonanzaRewards: false,
    airdrop: false,
    withdrawal: false,
    settings: false,
  });

  const [activeMenu, setActiveMenu] = useState({
    mainMenu: null,
    subMenu: null,
  });

  // Map routes to menu items
  const routeToMenuMap = {
    // Dashboard routes
    "/dashboard/quantum-vault": { main: "dashboard", sub: "quantum-vault" },
    "/dashboard/wallet-balance": { main: "dashboard", sub: "wallet-balance" },
    
    // Fund Management routes
    "/fund-management/fuel-deposit": { main: "fundManagement", sub: "fuel-deposit" },
    "/wallet-transfer": { main: "fundManagement", sub: "wallet-transfer" },
    "/fund-management/re-topup": { main: "fundManagement", sub: "re-topup" },
    "/wallet-transaction": { main: "fundManagement", sub: "wallet-transaction" },
    
    // Registration & Team routes
    "/registration/new-joining": { main: "registrationTeam", sub: "new-joining" },
    "/registration/crowd-signups": { main: "registrationTeam", sub: "crowd-signups" },
    "/registration/direct-leads": { main: "registrationTeam", sub: "direct-leads" },
    "/registration/team-network": { main: "registrationTeam", sub: "team-network" },
    
    // Income & Earnings routes
    "/income/level-income": { main: "incomeEarnings", sub: "level-income" },
    "/income/team-income": { main: "incomeEarnings", sub: "team-income" },
    "/income/senior-retopup-income": { main: "incomeEarnings", sub: "senior-retopup-income" },
    "/income/cmd-bonus": { main: "incomeEarnings", sub: "cmd-bonus" },
    "/income/24-max-directs": { main: "incomeEarnings", sub: "24-max-directs" },
    "/income/24-max-income": { main: "incomeEarnings", sub: "24-max-income" },
    "/income/24-lowest-income": { main: "incomeEarnings", sub: "24-lowest-income" },
    "/income/24-zero-income": { main: "incomeEarnings", sub: "24-zero-income" },
    "/income/roi-overview": { main: "incomeEarnings", sub: "roi-overview" },
    
    // Bonanza & Rewards routes
    "/bonanza/my-list": { main: "bonanzaRewards", sub: "my-list" },
    "/bonanza/awards-rewards": { main: "bonanzaRewards", sub: "awards-rewards" },
    
    // Airdrop routes
    "/airdrop/qi-airdrop": { main: "airdrop", sub: "qi-airdrop" },
    
    // Withdrawal routes
    "/withdrawal/funds": { main: "withdrawal", sub: "withdrawal-funds" },
    
    // Settings routes
    "/settings/my-profile": { main: "settings", sub: "my-profile" },
    "/settings/crypto-addresses": { main: "settings", sub: "crypto-addresses" },
    "/settings/security": { main: "settings", sub: "security-settings" },
    "/payment-report": { main: "settings", sub: "payment-report" },
  };

  // Set active menu based on current route
  useEffect(() => {
    const currentPath = location.pathname;
    const menuInfo = routeToMenuMap[currentPath];
    
    if (menuInfo) {
      setActiveMenu({
        mainMenu: menuInfo.main,
        subMenu: menuInfo.sub,
      });
      
      // Open the corresponding dropdown
      if (!openDropdowns[menuInfo.main]) {
        setOpenDropdowns(prev => ({
          ...prev,
          [menuInfo.main]: true
        }));
      }
    }
  }, [location.pathname]);

  const toggleDropdown = (key) => {
    setOpenDropdowns((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const handleMainMenuClick = (mainKey) => {
    setActiveMenu({
      mainMenu: mainKey,
      subMenu: null,
    });
    toggleDropdown(mainKey);
  };

  const handleSubMenuClick = (mainKey, subKey, route = null) => {
    setActiveMenu({
      mainMenu: mainKey,
      subMenu: subKey,
    });
    
    if (route) {
      navigate(route);
    }
    
    // Open the parent dropdown if not already open
    if (!openDropdowns[mainKey]) {
      setOpenDropdowns(prev => ({
        ...prev,
        [mainKey]: true
      }));
    }
  };

  // Check if a menu is active
  const isMainMenuActive = (key) => activeMenu.mainMenu === key;
  const isSubMenuActive = (key) => activeMenu.subMenu === key;

  return (
    <div className="sidebar-body">
      <ul className="nav" id="sidebarNav">
        {/* Dashboard */}
        <li className="nav-item has-dropdown">
          <a
            href="#dashboard"
            className={`nav-link d-flex align-items-center justify-content-between ${
              isMainMenuActive("dashboard") ? "main-menu-active" : ""
            }`}
            onClick={(e) => {
              e.preventDefault();
              handleMainMenuClick("dashboard");
            }}
            aria-expanded={openDropdowns.dashboard}
          >
            <div className="d-flex align-items-center">
              <i className="link-icon me-2" data-lucide="home"></i>
              <span className="link-title nav-item nav-category">
                Dashboard
              </span>
            </div>
            <i
              className={`dropdown-icon ${
                openDropdowns.dashboard ? "icon-rotate" : ""
              }`}
              data-lucide="chevron-down"
            ></i>
          </a>

          <ul
            className={`nav-dropdown ${
              openDropdowns.dashboard ? "show" : ""
            }`}
          >
            <li className="nav-dropdown-item">
              <a
                href="#"
                className={`nav-link d-flex align-items-center ${
                  isSubMenuActive("quantum-vault") ? "sub-menu-active" : ""
                }`}
                onClick={(e) => {
                  e.preventDefault();
                  handleSubMenuClick("dashboard", "quantum-vault", "/dashboard/quantum-vault");
                }}
              >
                <i className="link-icon me-2" data-lucide="vault"></i>
                <span className="link-title">Quantum Main Vault</span>
              </a>
            </li>

            <li className="nav-dropdown-item">
              <a
                href="#"
                className={`nav-link d-flex align-items-center ${
                  isSubMenuActive("wallet-balance") ? "sub-menu-active" : ""
                }`}
                onClick={(e) => {
                  e.preventDefault();
                  handleSubMenuClick("dashboard", "wallet-balance", "/dashboard/wallet-balance");
                }}
              >
                <i className="link-icon me-2" data-lucide="wallet"></i>
                <span className="link-title">My Wallet Balance</span>
              </a>
            </li>
          </ul>
        </li>

        {/* Fund Management */}
        <li className="nav-item has-dropdown">
          <a
            href="#fundManagement"
            className={`nav-link d-flex align-items-center justify-content-between ${
              isMainMenuActive("fundManagement") ? "main-menu-active" : ""
            }`}
            onClick={(e) => {
              e.preventDefault();
              handleMainMenuClick("fundManagement");
            }}
            aria-expanded={openDropdowns.fundManagement}
          >
            <div className="d-flex align-items-center">
              <i className="link-icon me-2" data-lucide="dollar-sign"></i>
              <span className="link-title nav-item nav-category">
                Fund Management
              </span>
            </div>
            <i
              className={`dropdown-icon ${
                openDropdowns.fundManagement ? "icon-rotate" : ""
              }`}
              data-lucide="chevron-down"
            ></i>
          </a>

          <ul
            className={`nav-dropdown ${
              openDropdowns.fundManagement ? "show" : ""
            }`}
          >
            <li className="nav-dropdown-item">
              <a
                href="#"
                className={`nav-link d-flex align-items-center ${
                  isSubMenuActive("fuel-deposit") ? "sub-menu-active" : ""
                }`}
                onClick={(e) => {
                  e.preventDefault();
                  handleSubMenuClick("fundManagement", "fuel-deposit", "/fund-management/fuel-deposit");
                }}
              >
                <i className="link-icon me-2" data-lucide="fuel"></i>
                <span className="link-title">FuelUp / Deposit</span>
              </a>
            </li>

            <li className="nav-dropdown-item">
              <a
                href="#"
                className={`nav-link d-flex align-items-center ${
                  isSubMenuActive("wallet-transfer") ? "sub-menu-active" : ""
                }`}
                onClick={(e) => {
                  e.preventDefault();
                  handleSubMenuClick("fundManagement", "wallet-transfer", "/wallet-transfer");
                }}
              >
                <i className="link-icon me-2" data-lucide="refresh-cw"></i>
                <span className="link-title">Wallet-to-Wallet Transfer</span>
              </a>
            </li>

            <li className="nav-dropdown-item">
              <a
                href="#"
                className={`nav-link d-flex align-items-center ${
                  isSubMenuActive("re-topup") ? "sub-menu-active" : ""
                }`}
                onClick={(e) => {
                  e.preventDefault();
                  handleSubMenuClick("fundManagement", "re-topup", "/fund-management/re-topup");
                }}
              >
                <i className="link-icon me-2" data-lucide="rotate-cw"></i>
                <span className="link-title">Re-TopUp (Mozumma)</span>
              </a>
            </li>

            <li className="nav-dropdown-item">
              <a
                href="#"
                className={`nav-link d-flex align-items-center ${
                  isSubMenuActive("wallet-transaction") ? "sub-menu-active" : ""
                }`}
                onClick={(e) => {
                  e.preventDefault();
                  handleSubMenuClick("fundManagement", "wallet-transaction", "/wallet-transaction");
                }}
              >
                <i className="link-icon me-2" data-lucide="file-text"></i>
                <span className="link-title">Wallet Transaction</span>
              </a>
            </li>
          </ul>
        </li>

        {/* Registration & Team */}
        <li className="nav-item has-dropdown">
          <a
            href="#registrationTeam"
            className={`nav-link d-flex align-items-center justify-content-between ${
              isMainMenuActive("registrationTeam") ? "main-menu-active" : ""
            }`}
            onClick={(e) => {
              e.preventDefault();
              handleMainMenuClick("registrationTeam");
            }}
            aria-expanded={openDropdowns.registrationTeam}
          >
            <div className="d-flex align-items-center">
              <i className="link-icon me-2" data-lucide="user-plus"></i>
              <span className="link-title nav-item nav-category">
                Registration & Team
              </span>
            </div>
            <i
              className={`dropdown-icon ${
                openDropdowns.registrationTeam ? "icon-rotate" : ""
              }`}
              data-lucide="chevron-down"
            ></i>
          </a>

          <ul
            className={`nav-dropdown ${
              openDropdowns.registrationTeam ? "show" : ""
            }`}
          >
            <li className="nav-dropdown-item">
              <a
                href="#"
                className={`nav-link d-flex align-items-center ${
                  isSubMenuActive("new-joining") ? "sub-menu-active" : ""
                }`}
                onClick={(e) => {
                  e.preventDefault();
                  handleSubMenuClick("registrationTeam", "new-joining", "/registration/new-joining");
                }}
              >
                <i className="link-icon me-2" data-lucide="user-plus"></i>
                <span className="link-title">
                  New Joining / Member Registration
                </span>
              </a>
            </li>

            <li className="nav-dropdown-item">
              <a
                href="#"
                className={`nav-link d-flex align-items-center ${
                  isSubMenuActive("crowd-signups") ? "sub-menu-active" : ""
                }`}
                onClick={(e) => {
                  e.preventDefault();
                  handleSubMenuClick("registrationTeam", "crowd-signups", "/registration/crowd-signups");
                }}
              >
                <i className="link-icon me-2" data-lucide="users"></i>
                <span className="link-title">Crowd Sign-Ups</span>
              </a>
            </li>

            <li className="nav-dropdown-item">
              <a
                href="#"
                className={`nav-link d-flex align-items-center ${
                  isSubMenuActive("direct-leads") ? "sub-menu-active" : ""
                }`}
                onClick={(e) => {
                  e.preventDefault();
                  handleSubMenuClick("registrationTeam", "direct-leads", "/registration/direct-leads");
                }}
              >
                <i className="link-icon me-2" data-lucide="user-check"></i>
                <span className="link-title">My Direct Leads</span>
              </a>
            </li>

            <li className="nav-dropdown-item">
              <a
                href="#"
                className={`nav-link d-flex align-items-center ${
                  isSubMenuActive("team-network") ? "sub-menu-active" : ""
                }`}
                onClick={(e) => {
                  e.preventDefault();
                  handleSubMenuClick("registrationTeam", "team-network", "/registration/team-network");
                }}
              >
                <i className="link-icon me-2" data-lucide="network"></i>
                <span className="link-title">My Team Network</span>
              </a>
            </li>
          </ul>
        </li>

        {/* Income & Earnings */}
        <li className="nav-item has-dropdown">
          <a
            href="#incomeEarnings"
            className={`nav-link d-flex align-items-center justify-content-between ${
              isMainMenuActive("incomeEarnings") ? "main-menu-active" : ""
            }`}
            onClick={(e) => {
              e.preventDefault();
              handleMainMenuClick("incomeEarnings");
            }}
            aria-expanded={openDropdowns.incomeEarnings}
          >
            <div className="d-flex align-items-center">
              <i className="link-icon me-2" data-lucide="trending-up"></i>
              <span className="link-title nav-item nav-category">
                Income & Earnings
              </span>
            </div>
            <i
              className={`dropdown-icon ${
                openDropdowns.incomeEarnings ? "icon-rotate" : ""
              }`}
              data-lucide="chevron-down"
            ></i>
          </a>

          <ul
            className={`nav-dropdown ${
              openDropdowns.incomeEarnings ? "show" : ""
            }`}
          >
            <li className="nav-dropdown-item">
              <a
                href="#"
                className={`nav-link d-flex align-items-center ${
                  isSubMenuActive("level-income") ? "sub-menu-active" : ""
                }`}
                onClick={(e) => {
                  e.preventDefault();
                  handleSubMenuClick("incomeEarnings", "level-income", "/income/level-income");
                }}
              >
                <i className="link-icon me-2" data-lucide="layers"></i>
                <span className="link-title">Level Income</span>
              </a>
            </li>

            <li className="nav-dropdown-item">
              <a
                href="#"
                className={`nav-link d-flex align-items-center ${
                  isSubMenuActive("team-income") ? "sub-menu-active" : ""
                }`}
                onClick={(e) => {
                  e.preventDefault();
                  handleSubMenuClick("incomeEarnings", "team-income", "/income/team-income");
                }}
              >
                <i className="link-icon me-2" data-lucide="users"></i>
                <span className="link-title">Team Income</span>
              </a>
            </li>

            <li className="nav-dropdown-item">
              <a
                href="#"
                className={`nav-link d-flex align-items-center ${
                  isSubMenuActive("senior-retopup-income") ? "sub-menu-active" : ""
                }`}
                onClick={(e) => {
                  e.preventDefault();
                  handleSubMenuClick("incomeEarnings", "senior-retopup-income", "/income/senior-retopup-income");
                }}
              >
                <i className="link-icon me-2" data-lucide="repeat"></i>
                <span className="link-title">Senior Re-TopUp Income</span>
              </a>
            </li>

            <li className="nav-dropdown-item">
              <a
                href="#"
                className={`nav-link d-flex align-items-center ${
                  isSubMenuActive("cmd-bonus") ? "sub-menu-active" : ""
                }`}
                onClick={(e) => {
                  e.preventDefault();
                  handleSubMenuClick("incomeEarnings", "cmd-bonus", "/income/cmd-bonus");
                }}
              >
                <i className="link-icon me-2" data-lucide="award"></i>
                <span className="link-title">CMD Bonus</span>
              </a>
            </li>

            <li className="nav-dropdown-item">
              <a
                href="#"
                className={`nav-link d-flex align-items-center ${
                  isSubMenuActive("24-max-directs") ? "sub-menu-active" : ""
                }`}
                onClick={(e) => {
                  e.preventDefault();
                  handleSubMenuClick("incomeEarnings", "24-max-directs", "/income/24-max-directs");
                }}
              >
                <i className="link-icon me-2" data-lucide="bar-chart-3"></i>
                <span className="link-title">24 Max Directs Report</span>
              </a>
            </li>

            <li className="nav-dropdown-item">
              <a
                href="#"
                className={`nav-link d-flex align-items-center ${
                  isSubMenuActive("24-max-income") ? "sub-menu-active" : ""
                }`}
                onClick={(e) => {
                  e.preventDefault();
                  handleSubMenuClick("incomeEarnings", "24-max-income", "/income/24-max-income");
                }}
              >
                <i className="link-icon me-2" data-lucide="trending-up"></i>
                <span className="link-title">24 Max Income Report</span>
              </a>
            </li>

            <li className="nav-dropdown-item">
              <a
                href="#"
                className={`nav-link d-flex align-items-center ${
                  isSubMenuActive("24-lowest-income") ? "sub-menu-active" : ""
                }`}
                onClick={(e) => {
                  e.preventDefault();
                  handleSubMenuClick("incomeEarnings", "24-lowest-income", "/income/24-lowest-income");
                }}
              >
                <i className="link-icon me-2" data-lucide="trending-down"></i>
                <span className="link-title">24 Lowest Income Report</span>
              </a>
            </li>

            <li className="nav-dropdown-item">
              <a
                href="#"
                className={`nav-link d-flex align-items-center ${
                  isSubMenuActive("24-zero-income") ? "sub-menu-active" : ""
                }`}
                onClick={(e) => {
                  e.preventDefault();
                  handleSubMenuClick("incomeEarnings", "24-zero-income", "/income/24-zero-income");
                }}
              >
                <i className="link-icon me-2" data-lucide="minus-circle"></i>
                <span className="link-title">24 Zero Income Report</span>
              </a>
            </li>

            <li className="nav-dropdown-item">
              <a
                href="#"
                className={`nav-link d-flex align-items-center ${
                  isSubMenuActive("roi-overview") ? "sub-menu-active" : ""
                }`}
                onClick={(e) => {
                  e.preventDefault();
                  handleSubMenuClick("incomeEarnings", "roi-overview", "/income/roi-overview");
                }}
              >
                <i className="link-icon me-2" data-lucide="pie-chart"></i>
                <span className="link-title">ROI Generation Overview</span>
              </a>
            </li>
          </ul>
        </li>

        {/* Bonanza & Rewards */}
        <li className="nav-item has-dropdown">
          <a
            href="#bonanzaRewards"
            className={`nav-link d-flex align-items-center justify-content-between ${
              isMainMenuActive("bonanzaRewards") ? "main-menu-active" : ""
            }`}
            onClick={(e) => {
              e.preventDefault();
              handleMainMenuClick("bonanzaRewards");
            }}
            aria-expanded={openDropdowns.bonanzaRewards}
          >
            <div className="d-flex align-items-center">
              <i className="link-icon me-2" data-lucide="gift"></i>
              <span className="link-title nav-item nav-category">
                Bonanza & Rewards
              </span>
            </div>
            <i
              className={`dropdown-icon ${
                openDropdowns.bonanzaRewards ? "icon-rotate" : ""
              }`}
              data-lucide="chevron-down"
            ></i>
          </a>

          <ul
            className={`nav-dropdown ${
              openDropdowns.bonanzaRewards ? "show" : ""
            }`}
          >
            <li className="nav-dropdown-item">
              <a
                href="#"
                className={`nav-link d-flex align-items-center ${
                  isSubMenuActive("my-list") ? "sub-menu-active" : ""
                }`}
                onClick={(e) => {
                  e.preventDefault();
                  handleSubMenuClick("bonanzaRewards", "my-list", "/bonanza/my-list");
                }}
              >
                <i className="link-icon me-2" data-lucide="gift"></i>
                <span className="link-title">My Bonanza List</span>
              </a>
            </li>

            <li className="nav-dropdown-item">
              <a
                href="#"
                className={`nav-link d-flex align-items-center ${
                  isSubMenuActive("awards-rewards") ? "sub-menu-active" : ""
                }`}
                onClick={(e) => {
                  e.preventDefault();
                  handleSubMenuClick("bonanzaRewards", "awards-rewards", "/bonanza/awards-rewards");
                }}
              >
                <i className="link-icon me-2" data-lucide="trophy"></i>
                <span className="link-title">Awards and Rewards</span>
              </a>
            </li>
          </ul>
        </li>

        {/* Airdrop */}
        <li className="nav-item has-dropdown">
          <a
            href="#airdrop"
            className={`nav-link d-flex align-items-center justify-content-between ${
              isMainMenuActive("airdrop") ? "main-menu-active" : ""
            }`}
            onClick={(e) => {
              e.preventDefault();
              handleMainMenuClick("airdrop");
            }}
            aria-expanded={openDropdowns.airdrop}
          >
            <div className="d-flex align-items-center">
              <i className="link-icon me-2" data-lucide="cloud-snow"></i>
              <span className="link-title nav-item nav-category">
                Airdrop
              </span>
            </div>
            <i
              className={`dropdown-icon ${
                openDropdowns.airdrop ? "icon-rotate" : ""
              }`}
              data-lucide="chevron-down"
            ></i>
          </a>

          <ul
            className={`nav-dropdown ${openDropdowns.airdrop ? "show" : ""}`}
          >
            <li className="nav-dropdown-item">
              <a
                href="#"
                className={`nav-link d-flex align-items-center ${
                  isSubMenuActive("qi-airdrop") ? "sub-menu-active" : ""
                }`}
                onClick={(e) => {
                  e.preventDefault();
                  handleSubMenuClick("airdrop", "qi-airdrop", "/airdrop/qi-airdrop");
                }}
              >
                <i className="link-icon me-2" data-lucide="cloud-snow"></i>
                <span className="link-title">QI Airdrop</span>
              </a>
            </li>
          </ul>
        </li>

        {/* Withdrawal */}
        <li className="nav-item has-dropdown">
          <a
            href="#withdrawal"
            className={`nav-link d-flex align-items-center justify-content-between ${
              isMainMenuActive("withdrawal") ? "main-menu-active" : ""
            }`}
            onClick={(e) => {
              e.preventDefault();
              handleMainMenuClick("withdrawal");
            }}
            aria-expanded={openDropdowns.withdrawal}
          >
            <div className="d-flex align-items-center">
              <i className="link-icon me-2" data-lucide="log-out"></i>
              <span className="link-title nav-item nav-category">
                Withdrawal
              </span>
            </div>
            <i
              className={`dropdown-icon ${
                openDropdowns.withdrawal ? "icon-rotate" : ""
              }`}
              data-lucide="chevron-down"
            ></i>
          </a>

          <ul
            className={`nav-dropdown ${
              openDropdowns.withdrawal ? "show" : ""
            }`}
          >
            <li className="nav-dropdown-item">
              <a
                href="#"
                className={`nav-link d-flex align-items-center ${
                  isSubMenuActive("withdrawal-funds") ? "sub-menu-active" : ""
                }`}
                onClick={(e) => {
                  e.preventDefault();
                  handleSubMenuClick("withdrawal", "withdrawal-funds", "/withdrawal/funds");
                }}
              >
                <i className="link-icon me-2" data-lucide="log-out"></i>
                <span className="link-title">Withdraw Funds</span>
              </a>
            </li>
          </ul>
        </li>

        {/* Settings */}
        <li className="nav-item has-dropdown">
          <a
            href="#settings"
            className={`nav-link d-flex align-items-center justify-content-between ${
              isMainMenuActive("settings") ? "main-menu-active" : ""
            }`}
            onClick={(e) => {
              e.preventDefault();
              handleMainMenuClick("settings");
            }}
            aria-expanded={openDropdowns.settings}
          >
            <div className="d-flex align-items-center">
              <i className="link-icon me-2" data-lucide="settings"></i>
              <span className="link-title nav-item nav-category">
                Settings
              </span>
            </div>
            <i
              className={`dropdown-icon ${
                openDropdowns.settings ? "icon-rotate" : ""
              }`}
              data-lucide="chevron-down"
            ></i>
          </a>

          <ul
            className={`nav-dropdown ${openDropdowns.settings ? "show" : ""}`}
          >
            <li className="nav-dropdown-item">
              <a
                href="#"
                className={`nav-link d-flex align-items-center ${
                  isSubMenuActive("my-profile") ? "sub-menu-active" : ""
                }`}
                onClick={(e) => {
                  e.preventDefault();
                  handleSubMenuClick("settings", "my-profile", "/settings/my-profile");
                }}
              >
                <i className="link-icon me-2" data-lucide="user"></i>
                <span className="link-title">My Profile</span>
              </a>
            </li>

            <li className="nav-dropdown-item">
              <a
                href="#"
                className={`nav-link d-flex align-items-center ${
                  isSubMenuActive("crypto-addresses") ? "sub-menu-active" : ""
                }`}
                onClick={(e) => {
                  e.preventDefault();
                  handleSubMenuClick("settings", "crypto-addresses", "/settings/crypto-addresses");
                }}
              >
                <i className="link-icon me-2" data-lucide="key"></i>
                <span className="link-title">Manage Crypto Addresses</span>
              </a>
            </li>

            <li className="nav-dropdown-item">
              <a
                href="#"
                className={`nav-link d-flex align-items-center ${
                  isSubMenuActive("security-settings") ? "sub-menu-active" : ""
                }`}
                onClick={(e) => {
                  e.preventDefault();
                  handleSubMenuClick("settings", "security-settings", "/settings/security");
                }}
              >
                <i className="link-icon me-2" data-lucide="shield"></i>
                <span className="link-title">Security Settings</span>
              </a>
            </li>

            <li className="nav-dropdown-item">
              <a
                href="#"
                className={`nav-link d-flex align-items-center ${
                  isSubMenuActive("payment-report") ? "sub-menu-active" : ""
                }`}
                onClick={(e) => {
                  e.preventDefault();
                  handleSubMenuClick("settings", "payment-report", "/payment-report");
                }}
              >
                <i className="link-icon me-2" data-lucide="file-text"></i>
                <span className="link-title">Payment Report</span>
              </a>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  );
};

export default Sidebar;